export default __webpack_public_path__ + "static/media/Rule14.a8c1718b.png";